import React, { FC } from "react";
import { Aligment, Icon } from "venice-ui";
import { Tabs } from "../UI/Tabs";
import { t } from "../../helpers/userHelper";
import { dictionary } from "../../untils/dictionary";
import { Scopes } from "../../definitionsNew/fields";
import { useStoreState } from "../../store";
import { useNavigate } from "react-router-dom";

interface IProjectDetailsHeader {
  activeTab: string;
  setActiveTab: (value: string) => void;
}
export const ProjectDetailsHeader: FC<IProjectDetailsHeader> = ({
  activeTab,
  setActiveTab,
}) => {
  const navigate = useNavigate();
  const { orgRole } = useStoreState((state) => state.user.userDetails);

  const menuTabs = [
    {
      value: "sections",
      label: t(dictionary.sections),
    },
    {
      value: "joints",
      label: t(dictionary.weldingLog),
    },
    // {
    //   value: "spools",
    //   label: t(dictionary.spools),
    // },
  ];

  // const goToConfig = () => {
  //   const config =
  //     activeTab === "sections" ? Scopes.SectionsList : Scopes.ListGlobal;

  //   navigate("/organization/list_setting", {
  //     state: { listConfig: config },
  //   });
  // };

  return (
    <Aligment justify="space-between">
      <Tabs tabs={menuTabs} activeValue={activeTab} onClick={setActiveTab} />
      {/* {orgRole === "admin" && (
        <Icon
          name="edit"
          iconBgHoverColor="transparent"
          size={18}
          onClick={goToConfig}
        />
      )} */}
    </Aligment>
  );
};
